<div class="card">

    <!-- Back Button -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Label: Regresar" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- Information Card -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>Label: Tabla Origen</span>
                    <p-cascadeSelect [disabled]="selectedMongoSyncTablesTo" style="width: 50%;"
                        [(ngModel)]="selectedMongoSyncTablesFrom" [options]="mongoSyncTables" optionLabel="cname"
                        optionGroupLabel="name" [optionGroupChildren]="['tables']" [style]="{'minWidth': '14rem'}"
                        placeholder="Seleccione una tabla origen" (ngModelChange)="filterMongoSyncValue()">
                    </p-cascadeSelect>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>Label: Tabla Destino</span>
                    <p-cascadeSelect [disabled]="!selectedMongoSyncTablesFrom" style="width: 50%;"
                        [(ngModel)]="selectedMongoSyncTablesTo" [options]="filteredMongoSyncTables" optionLabel="cname"
                        optionGroupLabel="name" [optionGroupChildren]="['tables']" [style]="{'minWidth': '14rem'}"
                        placeholder="Seleccione una tabla destino">
                    </p-cascadeSelect>
                </div>

            </p-panel>
        </div>
    </div>

    <!-- Table -->
    <p-table #dt [value]="versionHistoryList" [rows]="5" [paginator]="true"
        [globalFilterFields]="['versionDate','versionNum','summary','secre','treas','mater','school','internat','zone','national','local']"
        [(selection)]="selectedVersionHistoryList" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="Label: Mostrando {last} elementos de un total de {totalRecords} "
        [showCurrentPageReport]="true" responsive="true">

        <ng-template pTemplate="caption">
            <div class="p-d-flex p-flex-column">
                <h5 class="p-m-0"></h5>
                <div class="p-d-flex
                p-ai-center p-jc-between">
                    <span style="display: inline-flex;">

                        <button pButton pRipple label="Label: Analizar" icon="pi pi-search"
                            class="p-button-success p-mr-2 z-5" (click)="getMongoSync()"
                            [disabled]="!selectedMongoSyncTablesTo || !selectedMongoSyncTablesFrom"></button>

                        <button pButton pRipple label="Label: Sincronizar" icon="pi pi-sync"
                            class="p-button-danger p-mr-2 z-5" (click)="updateMongoSync()"
                            [disabled]="!selectedVersionHistoryList || !selectedVersionHistoryList.length"></button>

                    </span>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="Label: Buscar ..." />
                    </span>

                </div>
            </div>


        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>

                <th pSortableColumn="versionDate">Label: Id <p-sortIcon field="versionDate"></p-sortIcon></th>
                <th pSortableColumn="versionNum">Label: Valor <p-sortIcon field="versionNum"></p-sortIcon></th>
                <th pSortableColumn="summary">Label: Tabla | Servidor <p-sortIcon field="summary"></p-sortIcon></th>


            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-versionHistory>
            <tr>
                <td>
                    <p-tableCheckbox [value]="versionHistory"></p-tableCheckbox>
                </td>
                <td>{{ versionHistory.versionDate }}</td>
                <td>{{ versionHistory.versionNum }}</td>
                <td>{{ versionHistory.summary }}</td>
            </tr>

        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                Label: En total hay {{versionHistoryList ? versionHistoryList.length : 0 }} Label: elementos.
            </div>
        </ng-template>
    </p-table>
</div>


<!-- Alert & Confirm -->
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>